window.toggleEst = function (event, est) {
	if (event.type != 'keyup' || event.key === 'Enter') {
		let currActive = document.querySelector(
			'.inspections-table .establishment.active',
		)
		if (est != currActive) {
			if (currActive) {
				const currActiveSummary = currActive.querySelector('.summary')
				const currActiveDetails = currActive.querySelector('.details')
				currActiveSummary.setAttribute('aria-expanded', 'false')
				const currActiveNotifButton = currActiveSummary.querySelector(
					'.notification-button',
				)
				currActiveNotifButton?.toggleAttribute('hidden')
				currActiveNotifButton?.setAttribute('tabindex', '0')
				currActiveDetails.toggleAttribute('hidden')
				currActive.classList.remove('active')
			}

			const summary = est.querySelector('.summary')
			const details = est.querySelector('.details')
			summary.setAttribute(
				'aria-expanded',
				summary.getAttribute('aria-expanded') === 'false',
			)
			const notifButton = summary.querySelector('.notification-button')
			notifButton?.toggleAttribute('hidden')
			notifButton?.setAttribute('tabindex', '0')
			est.style.setProperty('--height', `${details.scrollHeight}px`)
			details.toggleAttribute('hidden')
			est.classList.add('active')
		}
	}
}

window.showEmailNotificationDialog = function (event, entryId, entryName) {
	if (event.type != 'keyup' || event.key === 'Enter') {
		const dialog = document.querySelector('.email-notification-dialog')
		const entryInput = dialog.querySelector('input[name=entry]')
		const establishmentName = dialog.querySelector('.establishment-name')
		console.log(entryName)
		establishmentName.innerText = entryName
		entryInput.value = entryId
		dialog.showModal()
	}
}

window.addEventListener('DOMContentLoaded', () => {
	// Handles active establishment for both mobile and desktop
	const establishments = document.querySelectorAll(
		'.inspections-table .establishment',
	)
	window.addEventListener('resize', e => {
		establishments.forEach(est => {
			est.setAttribute(
				'style',
				`--height: ${est.querySelector('.details')?.scrollHeight}px;`,
			)
		})
	})

	// Handles form
	const form = document.querySelector('.actions form')
	form?.addEventListener('submit', e => {
		e.preventDefault()
	})
})
